import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { DebtService } from "../services/debt-service";
import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";
import type { ITTargetMeasured } from "../common/targetmeasurd";
import dayjs from "dayjs";
import type { ColumnsType } from "antd/lib/table";
import { numberWithCommas } from "../../../utils";
import { DateTH } from "../../../utils/time-local";

export interface props {
  cif: string;
  baseURL: string;
  loading: boolean;
  accountNo: string;
}

const DebtTargetMeasured: React.FC<props> = ({
  cif,
  baseURL,
  loading,
  accountNo,
}): React.ReactElement => {
  const { id24Axios } = useId24();
  const appConfig = loadAppConfig();
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const debtService = DebtService;
  const [loadings, setLoading] = useState<boolean>(true);
  const [getData, setData] = useState<ITTargetMeasured[]>([]);

  useEffect(() => {
    if (loadings) {
      fecthdata();
    }
  }, [loadings]);

  const fecthdata = async () => {
    const response = await debtService(apiBaseUrlDebt).getTargetMeasured(
      accountNo,
      cif,
    );
    console.log(response);
    setData(response);
    setLoading(false);
  };

  const targetMeasuredColumns: ColumnsType<ITTargetMeasured> = [
    {
      title: "ชื่อมาตรการ",
      dataIndex: "program_name",
      key: "program_name",
    },
    {
      title: "ยอดขั้นต่ำที่ต้องชำระเพื่อปิดบัญชี",
      dataIndex: "close_acc",
      key: "close_acc",
      align: "right",
      render: (v) => (v ? numberWithCommas(v) : "-"),
    },
    {
      title: "หมายเลขการตรวจสอบ",
      dataIndex: "verified_number",
      key: "verified_number",
    },
    {
      title: "สถานะทางกฎหมาย",
      dataIndex: "legal_status",
      key: "legal_status",
    },
    {
      title: "เลขที่บัญชีเงินฝากผูกชำระสินเชื่อ",
      dataIndex: "saving_account_no",
      key: "saving_account_no",
    },
    {
      title: "เบอร์โทร MYMO",
      dataIndex: "tel_no",
      key: "tel_no",
    },
    {
      title: "MYMO STATE",
      dataIndex: "mymo_state",
      key: "mymo_state",
    },
    {
      title: "วันที่ Update",
      dataIndex: "update_date",
      key: "update_date",
      render: (v) => (v ? DateTH(v, "DD-MM-BBBB") : "-"),
    },
    {
      title: "รวมดอกเบี้ยบัญชี Sub",
      dataIndex: "int_total_sub_acc",
      key: "int_total_sub_acc",
      align: "right",
      render: (v) => (v ? numberWithCommas(v) : "-"),
    },

    {
      title: (
        <div style={{ textAlign: "center" }}>
          <div>{`รวมดอกเบี้ย`}</div>
          <div>{`(ดอกเบี้ยผิดนัด + ดอกเบี้ยบัญชี Sub + ดอกเบี้ยค้างรับ)`}</div>
        </div>
      ),
      dataIndex: "int_total",
      key: "int_total",
      align: "right",
      render: (v) => (v ? numberWithCommas(v) : "-"),
    },
    {
      title: "รวมภาระหนี้ (เงินต้น+ดอกเบี้ย) ",
      dataIndex: "outstanding_bal",
      key: "outstanding_bal",
      align: "right",
      render: (v) => (v ? numberWithCommas(v) : "-"),
    },
  ];
  return (
    <div>
      <h1>{`ข้อมูลการชี้เป้ามาตรการปิดบัญชี`}</h1>
      <Table
        size="small"
        dataSource={getData}
        scroll={{ x: "max-content" }}
        columns={targetMeasuredColumns}
        rowKey={"id"}
      />
    </div>
  );
};

export default DebtTargetMeasured;
